const { default: axios } = require("axios");

export class HttpClient {
  static getInstance() {
    return axios.create({
      baseURL: process.env.VUE_APP_API_BASE_URL,
    });
  }
}
